/**
 * 2019-04-11
 * handan
 * 页面底部
 */

import React, { Component } from 'react'
import "./style.scss";

class Footer extends Component{
  render(){
    return (
      <div className="footer-wrap">
        <div className="container">
          <div className="top">
            <span className="date">服务时间：工作日9:00—18:00</span>
            <span className="tel">服务电话：010-10105858</span>
            {/* <span className="email">服务邮箱：caojianlong@58.com</span> */}
          </div>
          <div className="copy">Copyright © 五八信息技术有限公司 版权所有</div>
        </div>
      </div>
    )
  }
}

export default Footer;